import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-home7',
  templateUrl: './home7.component.html',
  styleUrls: ['./home7.component.scss']
})
export class Home7Component implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('home7-page');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('home7-page');
  }
}
